import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import { TouchApp, Favorite } from "@mui/icons-material";

import WaxStamp from "../../../../../assets/imgs/wax-min.webp";
import {
	INVITATION_OCCASION,
	Invitations,
	TEMPLATES
} from "../../../../../store/services/invitations/dto/invitations.dto";
import { EnvelopeEntranceWrapper } from "./styles";
import { LANG_AR, LANG_EN, RTL } from "../../../../../Components/Templates/WeddingTemplates/constants";
import langEN from "../../../../../Components/Templates/WeddingTemplates/lang.EN.json";
import langAR from "../../../../../Components/Templates/WeddingTemplates/lang.AR.json";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const EnvelopeEntrance = ({
	openEnvelope,
	setOpenEnvelope,
	selectedInvitation,
	colorMatrix,
	preview
}: {
	openEnvelope: boolean;
	setOpenEnvelope: React.Dispatch<React.SetStateAction<boolean>>;
	selectedInvitation: Invitations;
	colorMatrix: TemplateColorObject;
	preview?: boolean;
}) => {
	const lang = selectedInvitation?.language === LANG_EN ? langEN : langAR;

	const invitationType = useMemo(() => {
		if (!selectedInvitation) return;
		switch (selectedInvitation?.occasion) {
			case INVITATION_OCCASION.KATB_KTAB: {
				return lang.the_katb_ktab_of;
			}
			case INVITATION_OCCASION.ENGAGEMENT: {
				return lang.the_engagement_of;
			}
			default: {
				return lang.the_wedding_of;
			}
		}
	}, [selectedInvitation]);

	return (
		<EnvelopeEntranceWrapper
			className={`${openEnvelope ? "hide" : "show"} ${preview ? "preview" : ""}`}
			onClick={() => setOpenEnvelope(true)}
			colormatrix={colorMatrix}
		>
			<div
				className={`animation_wrapper  animate__animated animate__bounceIn ${openEnvelope ? "open animate__fadeOutDown animate__delay-2s" : ""}`}
			>
				<div className={"lid one"}></div>
				<div className={"lid two"}></div>
				<div className={"envelope"}></div>
				<div className={`letter ${selectedInvitation?.language === LANG_AR && RTL}`}>
					<Typography className={"wedding_of"}>{invitationType}</Typography>
					<Box display={"flex"} justifyContent={"center"} gap={1} flexDirection={"row"} flexWrap={"wrap"}>
						<Typography className={"couples"}>{selectedInvitation?.groom_name}</Typography>
						<Typography className={"couples"}> {lang.and} </Typography>
						<Typography className={"couples"}> {selectedInvitation?.bride_name} </Typography>
					</Box>
				</div>
				<div
					className={`seal animate__animated animate__bounceIn ${openEnvelope ? "open animate__fadeOutDown animate__delay-2s" : ""}`}
				>
					<img src={WaxStamp} alt="wax stamp" loading={"eager"} />
					<Box className={"initials"}>
						<Typography className={`initial ${selectedInvitation?.language === LANG_AR ? "ar" : ""}`}>
							{(selectedInvitation?.groom_name || "").charAt(0)}
						</Typography>
						<Favorite />
						<Typography className={`initial ${selectedInvitation?.language === LANG_AR ? "ar" : ""}`}>
							{(selectedInvitation?.bride_name || "").charAt(0)}
						</Typography>
					</Box>
				</div>
			</div>
			<Box className={"tab_continue_container"} display={"flex"} flexDirection={"column"}>
				<Box
					className={`tab_continue ${openEnvelope ? "animate__animated animate__fadeOut" : "animate__animated  animate__headShake animate__delay-2s animate__infinite"}`}
				>
					<TouchApp />
				</Box>
				<Typography className={`tab_continue_text ${openEnvelope ? "animate__animated animate__fadeOut" : ""}`}>
					{lang.VIEW_INVITATION}
				</Typography>
			</Box>
		</EnvelopeEntranceWrapper>
	);
};

export default EnvelopeEntrance;
